import classNames from 'classnames';

import styles from './_index.module.scss';

export interface ScreenReaderOnlyProps extends React.HTMLAttributes<HTMLElement> {}

/**
 * ScreenReaderOnly
 * Visually hides an element (defaulting to span). For accessibility purposes, the wrapped
 * text/children are still available when using a screen reader. If a naturally focusable
 * element like `a` or `button` is used or if a `tabIndex` property is provided, the component
 * can be navigated to by tabbing and will remove the styles that hide the element.
 */
const ScreenReaderOnly = <T extends React.ElementType>({
  as,
  className,
  ...props
}: PolymorphicProps<T> & ScreenReaderOnlyProps) => {
  const Component = as || 'span';
  return <Component className={classNames(styles['screen-reader-only'], className)} {...props} />;
};

export default ScreenReaderOnly;
